import {
	clearReservationTime,
	changeReservationStep,
	getReservationTime,
	getReservationDateWithOrder,
} from 'actions/reservation';
import { getOrderById } from 'actions/booking';
import { closeAlert } from 'actions/alert';

import { withAsyncEnterLoader, withAsyncChangeLoader, withLoader } from 'util/routeHelper';
import { getRoomById } from 'actions/room';

export default store => ({
	path: 'checkin',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'BookingCheckin',
				),
			store,
			'BookingCheckin',
		),
	},
	onEnter: withAsyncEnterLoader(
		async (
			{ params: { id: orderId }, location: { query: { step = 'reservation' } } },
			__,
			updateRatio,
		) => {
			store.dispatch(closeAlert('reserve'));
			store.dispatch(changeReservationStep(step));
			await store.dispatch(getOrderById(orderId));
			updateRatio(0.8);

			if (step === 'reservation') {
				store.dispatch(clearReservationTime());

				const { booking } = store.getState();
				const roomId = booking.data[orderId].room.id;

				await Promise.all([
					store.dispatch(getRoomById(roomId)),
					store.dispatch(getReservationTime(booking.data[orderId].dateFrom, roomId, 'MORNING')),
					store.dispatch(getReservationTime(booking.data[orderId].dateFrom, roomId, 'AFTERNOON')),
					store.dispatch(getReservationDateWithOrder(orderId, 'CHECKIN')),
				]);
			}
		},
		store,
		'ENTER_BOOKING_CHECKIN',
	),
	onChange: withAsyncChangeLoader(
		async (
			_,
			{ params: { id: orderId }, location: { query: { step = 'reservation' } } },
			__,
			updateRatio,
		) => {
			store.dispatch(closeAlert('reserve'));
			store.dispatch(changeReservationStep(step));
			await store.dispatch(getOrderById(orderId));
			updateRatio(0.8);

			if (step === 'reservation') {
				store.dispatch(clearReservationTime());

				const { booking } = store.getState();
				const roomId = booking.data[orderId].room.id;

				await Promise.all([
					store.dispatch(getReservationTime(booking.data[orderId].dateFrom, roomId, 'MORNING')),
					store.dispatch(getReservationTime(booking.data[orderId].dateFrom, roomId, 'AFTERNOON')),
					store.dispatch(getReservationDateWithOrder(orderId, 'CHECKIN')),
				]);
			}
		},
		store,
		'CHANGE_BOOKING_CHECKIN',
	),
});



// WEBPACK FOOTER //
// ./src/routes/User/Booking/Checkin/index.js